import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import DIA4ULogo from '@/assets/images/dia4u_logo.png';
import TabLabelIcon from '@/components/TabLabel/TabLabelIcon';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import styles from './ValueByDIA4ULabel.module.scss';

interface ValueByDIA4ULabelProps {
  isFromTable?: boolean;
  isTableLegend?: boolean;
}

const ValueByDIA4ULabel = ({ isFromTable = false, isTableLegend = false }: ValueByDIA4ULabelProps) => {
  const { t } = useTranslation();

  return !isTableLegend
    ? (
      <TooltipComponent
        classes={{ tooltip: styles.TooltipFreeText }}
        arrow
        title={(
          <div className={styles.DIA4UTooltip}>
            <Typography variant="body2" component="span">{t(`dialog.valueByDIA4U`)}</Typography>
          </div>
        )}
      >
        <span className={styles.InfoIconContainer}>
          <TabLabelIcon isProvidedField extraClass={`${isFromTable ? styles.LessSizeIcon : ''}`} />
          {!isFromTable && (
            <div className={styles.DIA4ULogoContainer}>
              <img className={styles.DIA4ULogoLabel} src={DIA4ULogo} alt="DIA4U Logo" />
            </div>
          )}
        </span>
      </TooltipComponent>
    )
    : (
      <div className={styles.TableLeyend}>
        <TabLabelIcon isProvidedField extraClass={styles.MoreSizeIcon} />
        {t('dialog.valueBy')}
        <div className={styles.DIA4ULogoContainerTableLeyend}>
          <img src={DIA4ULogo} alt="DIA4U Logo" />
        </div>
      </div>
    );
};

export default ValueByDIA4ULabel;
